export const messagesAdmCreditManagement = {
    pt: {
        message:{
            addEmail: "Adicionar E-mail",
            addSms: "Adicionar SMS",
            addWhatsApp: "Adicionar WhatsApp",
            cancellationDate: "Cancelamento",
            cancelPlan: "Cancelar Plano",
            confirmationCancelPlan: "Quer mesmo cancelar o plano? Esta ação é irreversível",
            createdAt: "Criado",
            creditsMonth: "Crédito / Mês",
            currentPlan: "Plano Atual",
            expiration: "Expiração",
            expirationDate: "Data de Validade",
            linkPlan: "Vincular Plano",
            noCreditsRegistered: "Nenhum crédito cadastrado",
            questionCancelPlan:"Cancelar Plano?",
            totalAvailable: "Total Disponível",
            type:"Tipo",
            used:"Utilizado"
        }
    },
    es: {
        message:{
            addEmail:"Agregar correo electrónico",
            addSms:"Agregar SMS",
            addWhatsApp: "Agregar WhatsApp",
            cancellationDate:"Cancelación",
            cancelPlan:"Cancelar plan",
            confirmationCancelPlan:"¿Realmente quieres cancelar el plan? Esta acción es irreversible",
            createdAt:"Creado",
            creditsMonth:"Crédito / mes",
            currentPlan:"Plan actual",
            expiration:"Vencimiento",
            expirationDate:"Fecha de validez",
            linkPlan:"Plan de enlace",
            noCreditsRegistered:"Sin crédito registrado",
            questionCancelPlan:"¿Cancelar plan?",
            totalAvailable:"Total disponible",
            type:"Tipo",
            used:"Usado"
        }
    },
    en: {
        message:{
            addEmail: "Add E-mail",
            addSms: "Add SMS",
            addWhatsApp: "Add WhatsApp",
            cancellationDate: "Cancellation",
            cancelPlan: "Cancel Plan",
            confirmationCancelPlan: "Are you sure you to cancel it? This action is irreversible",
            createdAt: "Created",
            creditsMonth: "Credits / Month",
            currentPlan: "Current Plan",
            expiration: "Expiration",
            expirationDate: "Expiration Date",
            linkPlan: "Link Plan",
            noCreditsRegistered: "No credits registered",
            questionCancelPlan:"Cancel Plan?",
            totalAvailable: "Total Available",
            type:"Type",
            used:"Used"
        }
    }
}
